import { FunctionComponent } from 'react';
import cn from 'classnames';
import styles from './NotificationArea.module.css';
import {Dropdown, Image} from 'react-bootstrap';
import { ASSESTS } from '../../../../../constant/assest';
import { useNavigate } from "react-router-dom";
import { PageRoutes } from '../../../../../routing/paths';
import { useDispatch, useSelector } from 'react-redux';
import { logoutSuccess } from '../../../../../redux/slices/auth/slice';
import { RootState } from '../../../../../redux/store';
import Notification from '../Notification/Notification';
import { capitalizedUserName } from '../../../../../utils';
import { getColorForUser } from '../../../UserCard/UserCard';
import { UserType } from '../../../../../constant/enums';

interface INotificationAreaProps {
    menuClick: (e: React.MouseEvent) => void;
    className?: string;
}

const NotificationArea: FunctionComponent<INotificationAreaProps> = ({ menuClick, className}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state: RootState) => state.auth);
    const userImage = user?.profile_image;
    const bgColor = getColorForUser(user?.full_name || user?.username || 'N/A');
    
    const roleMap: Record<string, string> = {
        [UserType.SUPER_ADMIN]: "Super Admin",
        [UserType.SUB_ADMIN]: "Sub Admin",
        [UserType.USER]: "User",
    };

    const userRole = user?.role ? roleMap[user.role] : "";

    const handleLogout = () => {
        dispatch(logoutSuccess());
        navigate(PageRoutes.LOGIN, { replace: true });
    }

    return (
        <div className={cn(styles.notificationWrap, className)}>
            <button className={styles.sidebarToggler} onClick={menuClick}>
                <Image 
                    src={ASSESTS.MENUBTN}
                    alt="Menu Btn"
                />
            </button>
            <div className={styles.user}>
                <Dropdown>
                    <Dropdown.Toggle variant="light" className={styles.userDopdownBtn}>
                        <div className={cn(styles.userImg, !userImage && styles.userAvatarText)}
                        style ={!userImage ? { backgroundColor: bgColor } : undefined}>
                                {userImage ? 
                                <Image src={userImage} alt={user.full_name} width={48} height={48}/> : 
                                (user?.full_name ? user.full_name.trim()?.charAt(0).toUpperCase() : '?')
                            }
                        </div>
                        <div className={styles.userDetail}>
                            <div className={styles.userName}>{capitalizedUserName(user?.full_name)}</div>
                            <div className={styles.userDesignation}>{userRole}</div>
                        </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className={styles.userDopdown}>
                        <div className={styles.dropdowHeader}>
                            <div title={capitalizedUserName(user?.full_name)} className={styles.name}>{capitalizedUserName(user?.full_name)}</div>
                            <div title={userRole} className={styles.position}>{userRole}</div>
                            <div title={user?.email} className={styles.email}>{user?.email}</div>
                        </div>
                        <div className={styles.dropdownBody}>
                            <Dropdown.Item bsPrefix={styles.userDopdownItem} onClick={() => navigate(PageRoutes.ACCOUNTSETTINGS)}><Image src={ASSESTS.ACCOUNTSETTING} alt='Account Settings' width={20} height={20} /> Account Settings</Dropdown.Item>
                            <Dropdown.Item bsPrefix={styles.userDopdownItem} onClick={() => navigate(PageRoutes.ACCOUNTSETTINGS)}><Image src={ASSESTS.HELP} alt='Help' width={20} height={20} /> Help</Dropdown.Item>                         
                            <Dropdown.Item bsPrefix={cn(styles.userDopdownItem, styles.logoutBtn)} onClick={handleLogout}><Image src={ASSESTS.LOGOUT} alt='Log Out' width={19} height={19} /> Log Out</Dropdown.Item>
                        </div>
                    </Dropdown.Menu>                   
                </Dropdown>
            </div>
            <div className={styles.options}>
                <Notification />
            </div>
        </div>
    );
};

export default NotificationArea;
